import { useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPassword({ onSwitchToLogin }) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      // XHR adapter — see Login.jsx for the PostHog fetch monkey-patch note.
      await axios.post(
        `${API_URL}/api/auth/forgot-password`,
        { email },
        { adapter: "xhr", headers: { "Content-Type": "application/json" } }
      );
      setSent(true);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      if (typeof detail === "string") {
        setError(detail);
      } else if (err?.response) {
        setError("Something went wrong");
      } else {
        setError("Connection failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
      <div className="w-full max-w-sm">
        <div className="flex items-center justify-center gap-3 mb-12">
          <div className="w-12 h-12 bg-[#9FFF00] flex items-center justify-center">
            <span className="text-black font-black text-base">ID</span>
          </div>
          <h1 className="text-2xl font-black tracking-tight text-white">
            INFLUENCE<span className="text-[#9FFF00]">DETECTOR</span>
          </h1>
        </div>

        {sent ? (
          <div className="text-center">
            <p className="text-white text-sm mb-4">If an account exists with <strong>{email}</strong>, a reset link has been sent.</p>
            <button onClick={onSwitchToLogin} className="text-[#9FFF00] hover:underline text-sm font-medium">
              Back to Sign In
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <p className="text-white/50 text-sm text-center mb-4">Enter your email to receive a password reset link</p>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email address"
              className="w-full px-4 py-3 bg-white/5 border border-white/10 text-white placeholder-white/30 focus:outline-none focus:border-[#9FFF00] transition-colors"
              autoFocus
              data-testid="forgot-email-input"
            />
            {error && <p className="text-red-400 text-sm">{error}</p>}
            <button
              type="submit"
              disabled={loading || !email}
              className="w-full py-3 bg-[#9FFF00] text-black font-bold uppercase tracking-wider hover:bg-[#8AE600] disabled:opacity-50 transition-colors"
              data-testid="forgot-submit-button"
            >
              {loading ? "Sending..." : "Send Reset Link"}
            </button>
            <p className="text-white/40 text-sm text-center">
              <button onClick={onSwitchToLogin} className="text-[#9FFF00] hover:underline font-medium">
                Back to Sign In
              </button>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
